var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyDisabled = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.125 2.1875H13.125C13.3736 2.1875 13.6121 2.28627 13.7879 2.46209C13.9637 2.6379 14.0625 2.87636 14.0625 3.125V5.9375H16.875C17.1236 5.9375 17.3621 6.03627 17.5379 6.21209C17.7137 6.3879 17.8125 6.62636 17.8125 6.875V16.875C17.8125 17.1236 17.7137 17.3621 17.5379 17.5379C17.3621 17.7137 17.1236 17.8125 16.875 17.8125H6.875C6.62636 17.8125 6.3879 17.7137 6.21209 17.5379C6.03627 17.3621 5.9375 17.1236 5.9375 16.875V14.0625H3.125C2.87636 14.0625 2.6379 13.9637 2.46209 13.7879C2.28627 13.6121 2.1875 13.3736 2.1875 13.125V3.125C2.1875 2.87636 2.28627 2.6379 2.46209 2.46209C2.6379 2.28627 2.87636 2.1875 3.125 2.1875ZM7.8125 15.9375H15.9375V7.8125H7.8125V15.9375ZM4.0625 12.1875H5.9375V6.875C5.9375 6.62636 6.03627 6.3879 6.21209 6.21209C6.3879 6.03627 6.62636 5.9375 6.875 5.9375H12.1875V4.0625H4.0625V12.1875Z",
  fill: "#CAC4CF"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy_disabled.f30b7b86147588a9054da5f5810347db.svg";